/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/aria-role */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Col, ConfigProvider, DatePicker, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import ptBR from 'antd/lib/locale/pt_BR';
import moment from 'moment';

import { FaClipboardList } from 'react-icons/fa';
import api from '~/services/api';
import Row from '~/components/Row';
import DefautLayout from '~/pages/_layouts/full';
import PageTitle from '~/components/PageTitle';
import errorHandler from '~/Utils/errorHandler';
import { Table, TableActions, TableHeader } from '~/components/Table';
import Pagination from '~/components/Pagination';
import { decrypt } from '~/Utils/index';
import Button from '~/components/Button';
import { useIsMobile } from '~/Utils/isMob';
import { Box } from './styles';

export default function Home() {
  const { t } = useTranslation();
  const isMob = useIsMobile();
  const [loading, setLoading] = useState(false);
  const [recordData, setRecordData] = useState([]);
  const [veiculos, setVeiculos] = useState([]);
  const [historic, setHistoric] = useState([]);
  const [mobilizados, setMobilizados] = useState([]);
  const [meta, setMeta] = useState({});
  const [metaHistoric, setMetaHistoric] = useState({});
  const [metaMobilizados, setMetaMobilizados] = useState({});
  const [searchMobilizados, setSearchMobilizados] = useState('');
  const [dateMobilizados, setDateMobilizados] = useState('');
  const [searchDispo, setSearchDispo] = useState('');
  const [searchHistory, setSearchHistory] = useState('');
  const [dateMobilizadosHistorico, setDateMobilizadosHistorico] = useState('');
  const [dateDesmobilizadosHistorico, setDateDesmobilizadosHistorico] = useState('');

  const user =
    JSON.parse(decrypt(localStorage.getItem('@App:user'))) !== null &&
    JSON.parse(decrypt(localStorage.getItem('@App:user')));

  const fetchMobilizados = async (page = 1) => {
    setLoading(true);
    try {
      const params = {
        params: {
          page,
          search: searchMobilizados,
          saida: dateMobilizados,
        },
      };
      const { data } = await api.get(`/controle/mobilized`, params);

      setMobilizados(data.data);
      setMetaMobilizados(data.meta);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const fetchDisponiveis = async (page = 1) => {
    setLoading(true);
    try {
      const params = {
        params: {
          page,
          search: searchDispo,
        },
      };
      const { data } = await api.get(`/veiculos/available`, params);

      setVeiculos(data.data);
      setMeta(data.meta);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const fetchEmUso = async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/dashboard/emUso');
      if (!isEmpty(data)) {
        setRecordData([data]);
      }
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const fetchHistorico = async (page = 1) => {
    setLoading(true);
    try {
      const params = {
        params: {
          page,
          search: searchHistory,
          saida: dateMobilizadosHistorico,
          entrada: dateDesmobilizadosHistorico,
        },
      };
      const { data } = await api.get(`/controle/historic`, params);

      setHistoric(data.data);
      setMetaHistoric(data.meta);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchMobilizados();
    fetchDisponiveis();
    fetchEmUso();
    fetchHistorico();
  }, []);

  useEffect(() => {
    fetchMobilizados();
  }, [searchMobilizados, dateMobilizados]);

  useEffect(() => {
    fetchDisponiveis();
  }, [searchDispo]);

  useEffect(() => {
    fetchHistorico();
  }, [searchHistory, dateMobilizadosHistorico, dateDesmobilizadosHistorico]);

  const historicTableColumns = [
    {
      title: t('screens:relatorios.data.motorista'),
      dataIndex: 'checklist_users',
      key: 'motorista',
      width: '14.28%',
      responsive: ['sm', 'md', 'lg', 'xl', 'xxl'],
    },
    {
      title: t('screens:relatorios.data.veiculo'),
      dataIndex: 'veiculos_placa',
      key: 'veiculos',
      width: '14.28%',
      responsive: ['sm', 'md', 'lg', 'xl', 'xxl'],
    },
    {
      title: t('screens:relatorios.data.date'),
      dataIndex: 'saida',
      key: 'saida',
      width: '14.28%',
      responsive: ['sm', 'md', 'lg', 'xl', 'xxl'],
    },
    {
      title: t('Desmobilizado em'),
      dataIndex: 'entrada',
      key: 'entrada',
      width: '14.28%',
      responsive: ['sm', 'md', 'lg', 'xl', 'xxl'],
    },
    {
      title: t('KM inicial'),
      dataIndex: 'checklist_km_inicial',
      key: 'checklist_km_inicial',
      width: '4%',
      responsive: ['sm', 'md', 'lg', 'xl', 'xxl'],
    },
    {
      title: t('KM final'),
      dataIndex: 'checklist_km_final',
      key: 'checklist_km_final',
      width: '4%',
      responsive: ['sm', 'md', 'lg', 'xl', 'xxl'],
    },
    {
      title: t('KM rodados'),
      dataIndex: 'km_rodados',
      key: 'km_rodados',
      width: '4%',
      responsive: ['sm', 'md', 'lg', 'xl', 'xxl'],
    },
    {
      dataIndex: 'summary',
      key: 'summary',
      responsive: ['xs'],
      render: (text, record) => (
        <Col style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <Col>
            <strong>{t('screens:relatorios.data.motorista')}:</strong> {record.checklist_users}
          </Col>
          <Col>
            <strong>{t('screens:relatorios.data.veiculo')}:</strong> {record.veiculos_placa}
          </Col>
          <Col>
            <strong>{t('screens:relatorios.data.date')}:</strong> {record.saida}
          </Col>
          <Col>
            <strong>{t('Desmobilizado em')}:</strong> {record.entrada}
          </Col>
          <Col>
            <strong>{t('KM inicial')}:</strong> {record.checklist_km_inicial}
          </Col>
          <Col>
            <strong>{t('KM final')}:</strong> {record.checklist_km_final}
          </Col>
          <Col>
            <strong>{t('KM rodados')}:</strong> {record.km_rodados}
          </Col>
        </Col>
      ),
    },
  ].filter(item => item.hidden !== true);

  const tableColumnsVeiculos = [
    {
      title: t('screens:veiculos.data.id'),
      dataIndex: 'id',
      key: 'ids',
      responsive: ['sm', 'md', 'lg', 'xl', 'xxl'],
    },
    {
      title: t('screens:veiculos.data.placa'),
      dataIndex: 'placa',
      key: 'placa',
      responsive: ['sm', 'md', 'lg', 'xl', 'xxl'],
    },
    {
      title: t('screens:veiculos.data.modelo'),
      dataIndex: 'modelo',
      key: 'modelo',
      responsive: ['sm', 'md', 'lg', 'xl', 'xxl'],
    },
    {
      title: t('screens:users.data.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '135px',
      align: 'center',
      responsive: ['sm', 'md', 'lg', 'xl', 'xxl'],
      render: (text, record) => (
        <TableActions>
          <div style={{ textAlign: 'center' }}>
            <Link to={`/controle/${record.id}`} title={record.disponivel ? 'Mobilizar' : 'Desmobilizar'}>
              {record.disponivel ? 'Mobilizar' : 'Desmobilizar'}
              <FaClipboardList />
            </Link>
          </div>
        </TableActions>
      ),
    },
    {
      dataIndex: 'summary',
      key: 'summary',
      responsive: ['xs'],
      render: (text, record) => (
        <Col style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <Col>
            <strong>{t('screens:veiculos.data.id')}:</strong> {record.id}
          </Col>
          <Col>
            <strong>{t('screens:veiculos.data.placa')}:</strong> {record.placa}
          </Col>
          <Col>
            <strong>{t('screens:veiculos.data.modelo')}:</strong> {record.modelo}
          </Col>
          <Col style={{ marginTop: '6px' }}>
            <Link to={`/controle/${record.id}`} title={record.disponivel ? 'Mobilizar' : 'Desmobilizar'}>
              <Button style={{ backgroundColor: record.disponivel ? '' : 'red' }}>
                <FaClipboardList style={{ marginRight: 4 }} />
                {record.disponivel ? 'Mobilizar' : 'Desmobilizar'}
              </Button>
            </Link>
          </Col>
        </Col>
      ),
    },
  ];
  const tableColumnsMob = [
    {
      title: t('screens:veiculos.data.id'),
      dataIndex: 'id',
      key: 'ids',
      width: '20%',
      responsive: ['sm', 'md', 'lg'],
    },
    {
      title: t('screens:relatorios.data.motorista'),
      dataIndex: 'checklist_users',
      key: 'nome',
      width: '20%',
      responsive: ['sm', 'md', 'lg'],
    },
    {
      title: t('screens:veiculos.data.placa'),
      dataIndex: 'veiculos_placa',
      key: 'placa',
      width: '20%',
      responsive: ['md', 'lg'],
    },
    {
      title: t('screens:veiculos.data.modelo'),
      dataIndex: 'veiculos',
      key: 'modelo',
      width: '20%',
      responsive: ['lg', 'xl', 'xxl'],
      render: ({ modelo }) => <p>{modelo || ''}</p>,
    },
    {
      title: t('screens:relatorios.data.date'),
      dataIndex: 'saida',
      key: 'saida',
      width: '20%',
      responsive: ['sm', 'md', 'lg', 'xl', 'xxl'],
    },
    {
      title: t('screens:users.data.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '135px',
      align: 'center',
      responsive: ['sm', 'md', 'lg', 'xl', 'xxl'],
      render: (text, record) => (
        <TableActions>
          <div style={{ textAlign: 'center' }}>
            <Link to={`/controle/${record.veiculos?.id}`} title="Desmobilizar">
              Desmobilizar
              <FaClipboardList />
            </Link>
          </div>
        </TableActions>
      ),
    },
    {
      dataIndex: 'summary',
      key: 'summary',
      responsive: ['xs'],
      render: (text, record) => (
        <Col style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <Col>
            <strong>{t('screens:veiculos.data.id')}:</strong> {record.id}
          </Col>
          <Col>
            <strong>{t('screens:relatorios.data.motorista')}:</strong> {record.checklist_users}
          </Col>
          <Col>
            <strong>{t('screens:veiculos.data.placa')}:</strong> {record.veiculos_placa}
          </Col>
          <Col>
            <strong>{t('screens:veiculos.data.modelo')}:</strong> {record.veiculos?.modelo}
          </Col>
          <Col>
            <strong>{t('screens:relatorios.data.date')}:</strong> {record.saida}
          </Col>
          <Col style={{ marginTop: '4px' }}>
            <Link to={`/controle/${record.veiculos?.id}`} title="Desmobilizar">
              <Button>
                <FaClipboardList style={{ marginRight: 4 }} />
                Desmobilizar
              </Button>
            </Link>
          </Col>
        </Col>
      ),
    },
  ];

  return (
    <DefautLayout>
      {user.type === 'Admin' && (
        <>
          <PageTitle title="Veículo mobilizado por você" />
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Box>
                <Table
                  pagination={false}
                  rowKey="id2"
                  loading={loading}
                  dataSource={recordData}
                  columns={tableColumnsVeiculos}
                />
              </Box>
            </Col>
          </Row>
          <br />
          <br />

          <PageTitle title="Veículos mobilizados" />
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Box>
                <TableHeader style={{ display: 'flex', flexDirection: isMob ? 'column' : 'row', gap: 20 }}>
                  <ConfigProvider locale={ptBR}>
                    <DatePicker
                      placeholder="Data de mobilização"
                      onChange={data => setDateMobilizados(data ? moment(data).format('YYYY-MM-DD') : '')}
                      style={{ width: isMob ? '100%' : '11%' }}
                    />
                  </ConfigProvider>
                  <Input.Search
                    placeholder="Pesquise aqui"
                    onSearch={data => setSearchMobilizados(data)}
                    style={{ width: isMob ? '100%' : '20%' }}
                  />
                </TableHeader>
                <Table
                  pagination={false}
                  rowKey="id"
                  loading={loading}
                  dataSource={mobilizados}
                  columns={tableColumnsMob}
                />
                <Pagination
                  onChange={value => {
                    fetchMobilizados(value);
                  }}
                  meta={metaMobilizados}
                />
              </Box>
            </Col>
          </Row>
          <br />
          <br />
        </>
      )}

      <PageTitle
        title={
          veiculos[0]?.disponivel || user.type === 'Admin' ? 'Veículos disponíveis' : 'Veículo mobilizado por você'
        }
      />
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Box>
            <TableHeader style={{ display: 'flex', gap: 20 }}>
              <Input.Search
                placeholder="Pesquise aqui"
                onSearch={data => setSearchDispo(data)}
                style={{ width: isMob ? '100%' : '20%' }}
              />
            </TableHeader>
            <Table
              pagination={false}
              rowKey="id"
              loading={loading}
              dataSource={veiculos}
              columns={tableColumnsVeiculos}
            />
            <Pagination
              onChange={value => {
                fetchDisponiveis(value);
              }}
              meta={meta}
            />
          </Box>
        </Col>
      </Row>

      <br />
      <br />

      <PageTitle title="Histórico de mobilizações" />
      <Row>
        <Col xs={24} sm={24}>
          <Box>
            <TableHeader style={{ display: 'flex', gap: 20, flexDirection: isMob ? 'column' : 'row' }}>
              <ConfigProvider locale={ptBR}>
                <DatePicker
                  placeholder="Data de mobilização"
                  onChange={data => setDateMobilizadosHistorico(data ? moment(data).format('YYYY-MM-DD') : '')}
                  style={{ width: isMob ? '100%' : '11%' }}
                />
                <DatePicker
                  placeholder="Data de desmobilização"
                  onChange={data => setDateDesmobilizadosHistorico(data ? moment(data).format('YYYY-MM-DD') : '')}
                  style={{ width: isMob ? '100%' : '11%' }}
                />
              </ConfigProvider>
              <Input.Search
                placeholder="Pesquise aqui"
                onSearch={data => setSearchHistory(data)}
                style={{ width: isMob ? '100%' : '20%' }}
              />
            </TableHeader>
            <Table
              pagination={false}
              rowKey="id"
              loading={loading}
              dataSource={historic}
              columns={historicTableColumns}
            />
            <Pagination
              onChange={value => {
                fetchHistorico(value);
              }}
              meta={metaHistoric}
            />
          </Box>
        </Col>
      </Row>
    </DefautLayout>
  );
}
